import { useSyncExternalStore } from 'react';
import { exchangeLabel } from '@/lib/exchange';

/** The exchanges the app trades on. */
export type ExchangeId = 'binance' | 'okx';

/** The part of the store the price feed follows, so tests can pass their own. */
export type ExchangeSource = {
  get(): ExchangeId | null;
  subscribe(listener: () => void): () => void;
};

// The signed-in account's exchange, or null while it is not known yet (or nobody is signed in). Set by
// CurrentExchangeSync from the accounts list; read by the price feed and by the messages that name the exchange.
let current: ExchangeId | null = null;
const listeners = new Set<() => void>();

export function getCurrentExchange(): ExchangeId | null {
  return current;
}

export function setCurrentExchange(next: ExchangeId | null): void {
  if (next === current) return;
  current = next;
  for (const listener of [...listeners]) listener();
}

export function subscribeCurrentExchange(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export const currentExchangeSource: ExchangeSource = { get: getCurrentExchange, subscribe: subscribeCurrentExchange };

export function useCurrentExchange(): ExchangeId | null {
  return useSyncExternalStore(subscribeCurrentExchange, getCurrentExchange, getCurrentExchange);
}

/** The account's exchange as messages name it ("check OKX…"): Binance while it is not known, as before accounts existed. */
export function exchangeName(): string {
  return exchangeLabel(current ?? 'binance');
}
